import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CONVERSATIONS_QUERY_KEY } from '@/features/chat';
import { api } from '@/shared/lib/axios';

interface DeleteAllResponse {
  message: string;
  deletedCount: number;
}

export function useDeleteAllConversations() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await api.delete<DeleteAllResponse>('/api/chat/conversations');
      return res.data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CONVERSATIONS_QUERY_KEY }),
  });
}

export function useDeleteAccount() {
  return useMutation({
    mutationFn: async () => {
      await api.delete('/api/auth/account');
    },
  });
}

// Triggers a JSON download of the user's conversations + messages. Uses a Blob
// + anchor click rather than `window.open` so we can name the file and keep
// auth cookies on the same-origin fetch.
export function useExportData() {
  return useMutation({
    mutationFn: async () => {
      const res = await api.get<unknown>('/api/chat/export');
      const blob = new Blob([JSON.stringify(res.data, null, 2)], {
        type: 'application/json',
      });
      const stamp = new Date().toISOString().replace(/[:T]/g, '-').slice(0, 19);
      const url = URL.createObjectURL(blob);
      try {
        const a = document.createElement('a');
        a.href = url;
        a.download = `sahib-export-${stamp}.json`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } finally {
        URL.revokeObjectURL(url);
      }
      return { message: 'ok' };
    },
  });
}
